import { getRandomInt } from '@deltasierra/utilities-math';

/**
 * Shuffle an array using the inside-out algorithm.
 *
 * @param source - The source array to shuffle
 * @returns The shuffled array
 * @see https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle#The_.22inside-out.22_algorithm
 */
export function shuffle<T>(source: ArrayLike<T>): T[] {
    const shuffled: T[] = [];
    for (let index = 0; index < source.length; index++) {
        const swapIndex = getRandomInt(0, index, true);
        if (swapIndex !== index) {
            shuffled[index] = shuffled[swapIndex];
        }
        shuffled[swapIndex] = source[index];
    }
    return shuffled;
}
